import React, {memo} from 'react';
import {StyleSheet, View} from 'react-native';

import TagLightIcon from 'src/components/img/svg/TagLightIcon';
import AVText from '../../elements/AVText';
import AVFormattedCurrency from '../../elements/AVFormattedCurrency';
import AccountStore from 'src/stores/AccountStore';
import {scanAndPayTemplate} from './templates/scanandPayThemeHelper';

export interface DiscountShape {
  discountHeaderId?: string | number;
  displayName?: string;
  discount?: number;
  isStackedDiscount?: boolean;
}

interface Props {
  discount: DiscountShape;
  color: string;
  testID?: string;
}

const DiscountLine: React.FC<Props> = ({discount, color, testID}) => (
  <View style={styles.row} accessible testID={testID} nativeID={testID}>
    <View style={scanAndPayTemplate.checkoutStyles.cartDescriptionSubView}>
      <View style={styles.icon}>
        <TagLightIcon
          fill={color}
          width={scanAndPayTemplate.discountTagDimensions.width}
          height={scanAndPayTemplate.discountTagDimensions.height}
        />
      </View>
      <View
        style={[
          styles.textWrap,
          !discount?.discount && styles.rewardDiscountLabel,
        ]}
      >
        <AVText
          numberOfLines={discount?.isStackedDiscount ? 0 : 6}
          ellipsizeMode="tail"
          style={[styles.text, {color}]}
        >
          {(discount?.isStackedDiscount
            ? discount.displayName
            : discount.displayName?.substring(0, 30)) ?? 'Promotion'}{' '}
          {discount?.discount && (
            <AVText>
              (
              <AVFormattedCurrency
                value={-discount.discount}
                currency={AccountStore.getCurrency()}
              />
              )
            </AVText>
          )}
        </AVText>
      </View>
    </View>
  </View>
);

export default memo(DiscountLine);

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  icon: {
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  textWrap: {
    flex: 0.7,
    flexDirection: 'row',
    left: 5,
  },
  text: {
    fontWeight: '400',
    fontSize: scanAndPayTemplate.promoFontSize,
    fontFamily: scanAndPayTemplate.textFontFamily,
  },
  rewardDiscountLabel: {
    flex: 0.8,
  },
});
